export default function PHP_get_defined_vars() {
  return (
    <div>
      <h1>PHP_get_defined_vars</h1>
    </div>
  );
}
